import { render } from "./SubmittedThemes.vue?vue&type=template&id=669aae40&scoped=true"
import script from "./SubmittedThemes.vue?vue&type=script&lang=js"
export * from "./SubmittedThemes.vue?vue&type=script&lang=js"

import "../css/SubmittedDispositions.css?vue&type=style&index=0&id=669aae40&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Korisnik\\Desktop\\3. Semestar Mag\\VUI\\DiplomaInsight\\DiplomaInsight\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-669aae40"]])

export default __exports__